import React from "react";
import mifoto from "../imgs/DSC_1510.jpg";
const AboutMe = ({ language = 'es' }) => {
  // Traducciones en español e inglés
  const translations = {
    es: {
      title: "Sobre mí",
      intro: "¡Hola! Mi nombre es ",
      age: "tengo ",
      career: " y soy ",
      journey: "Mi viaje en la programación comenzó hace aproximadamente ",
      experience: "Me especializo en desarrollo ",
      fullStack: "Full Stack",
      frontend: "frontend",
      backend: "backend",
      analysis: "análisis",
      dataScienceSpan: "ciencia de datos",
      goal: "Mi objetivo es seguir aprendiendo, colaborar en proyectos creativos y compartir mi conocimiento con la comunidad tecnológica. ",
      letsGo: "¡Vamos por más! 🚀",
    },
    en: {
      title: "About Me",
      intro: "Hello! My name is ",
      age: "I am ",
      career: " and I am a ",
      journey: "My journey in programming started about ",
      experience: "I specialize in ",
      fullStack: "Full Stack",
      frontend: "frontend",
      backend: "backend",
      analysis: "data analysis",
      dataScienceSpan: "data science",
      goal: "My goal is to continue learning, collaborate on creative projects, and share my knowledge with the tech community. ",
      letsGo: "Let's go for more! 🚀",
    },
  };

  // Seleccionar el idioma
  const t = translations[language] || translations.es;

  return (
    <section className="bg-black text-white min-h-screen flex items-center justify-center">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16 lg:py-20">
        <div className="flex flex-col lg:flex-row items-center justify-center gap-8 lg:gap-16">
          
          {/* Imagen - Aparece primera en móvil */}
          <div className="flex-shrink-0 order-1 lg:order-2">
            <div className="relative group">
              <img
                src={mifoto}
                alt="Julián Abril - Desarrollador Full Stack"
                loading="lazy"
                className="w-48 h-48 sm:w-56 sm:h-56 md:w-64 md:h-64 lg:w-72 lg:h-72 xl:w-80 xl:h-80 rounded-2xl object-cover shadow-2xl transition-all duration-500 ease-out group-hover:scale-105 group-hover:rotate-3 lg:rotate-6"
              />
              {/* Efecto de resplandor */}
              <div className="absolute inset-0 rounded-2xl bg-gradient-to-tr from-yellow-400/20 via-transparent to-purple-400/20 opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
              {/* Sombra colorida */}
                 </div>
          </div>

          {/* Contenido de texto */}
          <div className="flex-1 order-2 lg:order-1 text-center lg:text-left max-w-2xl">
            
            {/* Título */}
            <div className="mb-8 sm:mb-10">
              <h2 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-jersey mb-4 bg-gradient-to-r from-white via-gray-200 to-gray-400 bg-clip-text text-transparent">
                {t.title}
              </h2>
              <div className="w-16 sm:w-20 h-1 bg-gradient-to-r from-yellow-400 to-purple-400 mx-auto lg:mx-0 rounded-full"></div>
            </div>

            {/* Párrafos de contenido */}
            <div className="space-y-6 sm:space-y-8">
              
              {/* Párrafo 1 - Introducción */}
              <p className="text-base sm:text-lg md:text-xl leading-relaxed font-medium text-gray-300">
                {t.intro}
                <span className="font-bold text-yellow-400 hover:text-yellow-300 transition-colors duration-300">
                  Julián Abril
                </span>
                , {t.age}
                <span className="font-bold text-yellow-400 hover:text-yellow-300 transition-colors duration-300">
                  20
                </span>
                {language === 'es' ? ' años' : ' years old'} {t.career}
                <span className="font-bold text-yellow-400 hover:text-yellow-300 transition-colors duration-300">
                  {language === 'es' ? 'Ingeniero de Sistemas' : 'Systems Engineer'}
                </span>
                . {t.journey}
                <span className="font-bold text-yellow-400 hover:text-yellow-300 transition-colors duration-300">
                  {language === 'es' ? '2 años' : '2 years'}
                </span>
                .
              </p>

              {/* Párrafo 2 - Experiencia */}
              <p className="text-base sm:text-lg md:text-xl leading-relaxed font-medium text-gray-300">
                {t.experience}
                <span className="font-bold text-purple-400 hover:text-purple-300 transition-colors duration-300 italic">
                  {t.fullStack}
                </span>
                , {language === 'es' ? 'creando aplicaciones tanto en el' : 'creating applications in both'}{" "}
                <span className="font-bold text-purple-400 hover:text-purple-300 transition-colors duration-300 italic">
                  {t.frontend}
                </span>
                {language === 'es' ? ' como en el' : ' and'}{" "}
                <span className="font-bold text-purple-400 hover:text-purple-300 transition-colors duration-300 italic">
                  {t.backend}
                </span>
                . {language === 'es' ? 'Me apasiona construir soluciones tecnológicas innovadoras' : 'I am passionate about building innovative technological solutions'}.
              </p>

              {/* Párrafo 3 - Objetivo */}
              <p className="text-base sm:text-lg md:text-xl leading-relaxed font-medium text-gray-300">
                {t.goal}
                <span className="font-bold text-cyan-400 hover:text-cyan-300 transition-colors duration-300 inline-block hover:scale-110 transform transition-transform duration-300">
                  {t.letsGo}
                </span>
              </p>

            </div>

            {/* Elementos decorativos */}
            <div className="mt-12 sm:mt-16 flex justify-center lg:justify-start">
              <div className="flex space-x-2">
                <div className="w-3 h-3 bg-yellow-400 rounded-full animate-pulse"></div>
                <div className="w-3 h-3 bg-purple-400 rounded-full animate-pulse delay-100"></div>
                <div className="w-3 h-3 bg-cyan-400 rounded-full animate-pulse delay-200"></div>
              </div>
            </div>

          </div>

        </div>
      </div>
    </section>
  );
};

export default AboutMe;